@if (aufgabe().body['retentAnlegen']) {
	<div class="c-row">
		<span>Retent anlegen</span>
	</div>
}
@if (aufgabe().body['anGerichtSenden']) {
	<div class="c-row">
		<span>an AG {{ aufgabe().body['gericht'] }} senden</span>
	</div>
}
@if (aufgabe().body['umEintragungsnachrichtBitten']) {
	<div class="c-row">
		<span>um Eintragungsnachricht wird gebeten</span>
	</div>
}
